import React, { useMemo } from "react";
import LayoutAgentRank from "layouts/layout-agent-rank";
import {
  AgentRankingProvider,
  useAgentRanking,
} from "./context/AgentRankingContext";
import { TierProvider } from "./context/TierContext";
import { SeasonHistoryProvider } from "./context/SeasonHistoryContext";
import { AgentPointsLogProvider } from "./context/AgentPointsLogContext";
import PrintJson from "utils/printJson";
// import { getContrastColor } from "utils/utils";
import AgentLevelsSection from "./AgentLevelsSection";
import TopAgentsSection from "./TopAgentsSection";
import RankingListSection from "./RankingListSection";
import SeasonHistorySection from "./SeasonHistorySection";
import PermissionMiddleware from "middleware/PermissionMiddleware";

function AgentRankBoardContent() {
  const { rankings, refetch, Pagination } = useAgentRanking();

  // Calculate agent levels from rankings summary data
  const agentLevels = useMemo(() => {
    if (!rankings.summary || !rankings.summary.top_tiers) {
      return [];
    }

    return rankings.summary.top_tiers.map((topTier) => {
      return {
        count: topTier.agent_count,
        tier: topTier.tier.name.toLowerCase(),
        label: "Agent",
        color: topTier.tier.color,
        name: topTier.tier.name,
        image: topTier.tier.image_url,
        id: topTier.tier.id,
      };
    });
  }, [rankings.summary]);

  // Get top 5 agents from rankings data
  const topAgents = useMemo(() => {
    if (!rankings.data || rankings.data.length === 0) {
      return [];
    }

    return rankings.data.slice(0, 5).map((ranking, index) => {
      return {
        id: ranking.id,
        name: ranking.agent?.name || "Unknown Agent",
        tier: ranking.tier?.name?.toLowerCase() || "bronze",
        tierName: ranking.tier?.name || "Bronze",
        tierColor: ranking.tier?.color || "#6b7280",
        agentColor: ranking.agent?.color || "#6b7280",
        image: ranking.tier?.image_url,
        points: ranking.points || 0,
      };
    });
  }, [rankings.data]);

  return (
    <LayoutAgentRank>
      <div className="container-fluid mt-5 agent-rank-page">
        <h1>AGENT RANKING - BOARD</h1>
        <h2
          style={{ fontSize: "18px", color: "#6b7280", marginBottom: "20px" }}
        >
          Active Session:{" "}
          {rankings.data && rankings.data.length > 0
            ? rankings.data[0].season?.name || "Unknown Session"
            : "Loading..."}
        </h2>

        <style>
          {`
          @media (max-width: 768px) {
            .container-fluid {
              padding-left: 8px;
              padding-right: 8px;
            }
            h1 {
              font-size: 24px;
            }
            .card-body h2 {
              font-size: 18px;
            }
            .agent-card {
              padding: 12px !important;
            }
            .agent-card .agent-name {
              font-size: 14px !important;
            }
            .agent-card .tier-name {
              font-size: 12px !important;
            }
          }
          @media (max-width: 576px) {
            .agent-grid {
              grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)) !important;
            }
            .top-agents-grid {
              grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)) !important;
            }
          }
          `}
        </style>

        <div
          style={{
            minHeight: "100vh",
          }}
        >
          <AgentLevelsSection agentLevels={agentLevels} />
          <TopAgentsSection topAgents={topAgents} />
          <RankingListSection
            rankings={rankings}
            refetch={refetch}
            Pagination={Pagination}
          />
          <SeasonHistorySection />
        </div>
      </div>
      <PermissionMiddleware allowedRoles={["superadmin"]}>
        <PrintJson data={{ rankings }} />
      </PermissionMiddleware>
    </LayoutAgentRank>
  );
}

export default function AgentRankBoard() {
  return (
    <TierProvider>
      <AgentRankingProvider>
        <SeasonHistoryProvider>
          <AgentPointsLogProvider>
            <AgentRankBoardContent />
          </AgentPointsLogProvider>
        </SeasonHistoryProvider>
      </AgentRankingProvider>
    </TierProvider>
  );
}
